<div class="produit-complementaire-panneau">

  <div class="produit-complementaire-barre-outils">
    <yo-button
      tooltip="Associer des points de livraison"
      iconClass="fas fa-plus"
      [theme]="ButtonThemeEnum.ADD"
      (onClick)="openDialogAjout()"
      [disabled]="!canEdit()">
    </yo-button>

    <div class="produit-complementaire-barre-outils-actions">
      <dx-text-box
        mode="search"
        placeholder="Recherche"
        valueChangeEvent="change"
        [width]="250"
        (onValueChanged)="onSearchChanged($event)">
      </dx-text-box>

      <yo-button
        tooltip="Enregistrer"
        type="submit"
        iconClass="fas fa-save"
        [theme]="ButtonThemeEnum.SAVE"
        (onClick)="save()"
        [disabled]="!canEdit() || !hasChanges()">
      </yo-button>
    </div>
  </div>

  <yo-produit-complementaire-grid
    [produitComplementaireList]="produitComplementaireList()"
    [keyExpr]="KEY_EXPR"
    [plcColonneVisible]="true"
    [editable]="canEdit()"
    noDataText="Aucun point de livraison associé aux produits complémentaires de ce produit"
    suppressionTooltip="Supprimer l'association au point de livraison"
    (periodeClick)="openDialogPeriode($event)"
    (suppressionClick)="supprimer($event)"
    (jourClick)="toggleJour($event)"
    (ligneEditee)="onLigneEditee()">
  </yo-produit-complementaire-grid>

  <dx-pagination
    class="produit-complementaire-pager"
    [pageSize]="PAGE_SIZE"
    [itemCount]="totalElements()"
    [pageIndex]="currentPage()"
    (pageIndexChange)="onPageIndexChange($event)"
    [showInfo]="true"
    [showNavigationButtons]="true"
    [showPageSizeSelector]="false"
    infoText="Page {0} sur {1} ({2} associations)">
  </dx-pagination>
</div>

<yo-dialog-ajout-association
  [(visible)]="dialogAjoutVisible"
  [produitDeclinaisonList]="produitDeclinaisonComplementaireList">
</yo-dialog-ajout-association>

<yo-dialog-periode-conditionnement
  [(visible)]="dialogPeriodeVisible"
  [produit]="produitPeriode()"
  (periodeListChange)="onPeriodeListChange($event)">
</yo-dialog-periode-conditionnement>
